<!-- added by priya 17-04-2026 -->
<button
  mat-icon-button
  [matMenuTriggerFor]="menu"
  #menuTrigger="matMenuTrigger"
  style="display: none;">
</button>
<!-- end by priya 17-04-2026 -->

<mat-menu #menu="matMenu" class="column-settings-menu" (closed)="onMenuClosed()">
  
  <div (click)="$event.stopPropagation(); $event.preventDefault();">
    <div class="settings-header" [class.export-enabled]="hasExportOptions">
      <div class="settings-col col-label-header">Column Settings</div>
      <div class="settings-col show-col col-label-header">Show</div>
      <div class="settings-col" *ngIf="hasExportOptions">
        Show in Export
      </div>
    </div>

    <div class="settings-divider"></div>

    <ng-container *ngFor="let c of columns">
      <div
        class="settings-row"
        [class.export-enabled]="hasExportOptions"
        *ngIf="!c.alwaysVisible && !c.hideMenu">

        <div class="settings-col col-label">
          {{ c.label }}
        </div>

        <div class="settings-col checkbox-col" style="cursor: pointer;" (click)="handleColClick($event, c)">
          <mat-checkbox
            [checked]="localDisplayedColumns.includes(c.key)"
            [disabled]="c.hideable === false"
            style="pointer-events: none;">
          </mat-checkbox>
        </div>

        <div class="settings-col checkbox-col" *ngIf="hasExportOptions">
          <div *ngIf="c.showExportOption" style="cursor: pointer; width: 100%; display: flex; justify-content: center;" (click)="handleExpClick($event, c)">
            <mat-checkbox
              [checked]="localExportColumns.has(c.key)"
              style="pointer-events: none;">
            </mat-checkbox>
          </div>
        </div>

      </div>
    </ng-container>
  </div>
</mat-menu>
